import { TextH1Medium } from 'lib.typography';
import './styles.scss';

interface AvatarProps {
  url: string;
  size?: 'medium' | '50' | '68' | '44' | '38' | '32' | '31' | '24' | '106' | '86';
  bordered?: boolean;
  isCover?: boolean;
  name?: string;
  shape?: 'circle' | 'square';
}

const Avatar = ({
  url,
  size = 'medium',
  bordered,
  isCover,
  name,
  shape = 'circle',
}: AvatarProps) => {
  const initials = name
    ? name
        .trim()
        .split(' ')
        .filter((word) => word.length > 0)
        .reduce((acc, word, index, arr) => {
          if (arr.length === 1) {
            // For single names, take up to 2 characters
            return word.substring(0, 2).toUpperCase();
          }
          // For multiple names, take first letter of first 2 words
          return index < 2 ? acc + word[0].toUpperCase() : acc;
        }, '')
    : '';

  return url ? (
    <img
      className={`avatar-img avatar-img__${size} ${bordered ? 'avatar-img__bordered' : ''} ${isCover ? 'avatar-img__cover' : ''} ${shape === 'square' ? 'avatar-img__square' : ''}`}
      src={url}
      alt="."
    />
  ) : (
    <div
      className={`avatar-img avatar-img__${size} ${bordered ? 'avatar-img__bordered' : ''} ${shape === 'square' ? 'avatar-img__square' : ''}`}
    >
      <TextH1Medium className="avatar-text">{initials}</TextH1Medium>
    </div>
  );
};

export default Avatar;
